import {FC} from "react";
import {Avatar, AvatarProps} from "antd";
import {stringToColor} from "../../utils/stringToColor.ts";
import {User} from "../../types/domain.ts";

type Props = AvatarProps & { user: User };

export const UserAvatar: FC<Props> = ({ user, ...rest }) => (
    <Avatar
        {...rest}
        style={{ backgroundColor: stringToColor(`${user.first_name[0]}${user.last_name[0]}`), flexShrink: '0' }}
    >
        {user.first_name[0]}{user.last_name[0]}
    </Avatar>
)